import { useEffect } from "react";
export const useDocumentTitle = (title: String) => {

  useEffect(() => {
    document.title = `${title} - IEP Tools`;
  }, [title]);

  return null;
};

export const setTitle = (parts: (String | undefined)[]) => {
  document.title = [...parts, "IEP Tools"].filter(p => p !== null && p !== undefined && p.length > 0).join(' - ');
}